import useAuth from 'src/hooks/useAuth';
import { Policies } from 'src/types/policies';

/**
 * Returns true if the current user has the given policy or any in the list.
 * @example usePolicy(Policies.Administrator)
 * @example usePolicy([Policies.FloorManager, Policies.StationReset])
 */
const usePolicy = (policy: Policies | Policies[]): boolean => {
  const { user } = useAuth();
  const granted = user?.policies ?? [];
  const required = Array.isArray(policy) ? policy : [policy];
  return required.some((p) => granted.includes(p));
};

export default usePolicy;
